import { CustomEventTypes } from "../models/enum/custom-event-types.enum";

declare const window: any;

export class DomEventsSubscribe {
    private resizeWatchers = new Map<string, Array<Function>>();
    private loadWatchers = new Map<string, Array<Function>>();
    private documentClickWatchers = new Map<string, Array<Function>>();
    private escPressWatchers = new Map<string, Array<Function>>();
    private deletePressWatchers = new Map<string, Array<Function>>();
    private scrollWatchers = new Map<string, Array<Function>>();
    private unloadWatchers = new Map<string, Array<Function>>();
    private messageWatchers = new Map<string, Array<Function>>();
    private popStateWatchers = new Map<string, Array<Function>>();
    private contextMenuWatchers = new Map<string, Array<Function>>();
    private mouseOverWatchers = new Map<string, Array<Function>>();
    private mouseLeaveWatchers = new Map<string, Array<Function>>();
    private mouseMoveWatchers = new Map<string, Array<Function>>();
    private mouseDownWatchers = new Map<string, Array<Function>>();
    private mouseUpWatchers = new Map<string, Array<Function>>();
    private bodyClickWatchers = new Map<string, Array<Function>>();
    private customerEventWatchers = new Map<CustomEventTypes, Map<string, Array<Function>>>();

    constructor() {
        this.watchOnLoad();
        this.watchOnResize();
        this.watchDocumentClick();
        this.watchEscPress();
        this.watchDeletePress();
        this.watchOnScroll();
        this.watchOnWindowUnload();
        this.watchOnMessage();
        this.watchOnContextMenu();
        this.watchOnPopStateChange();
        this.watchOnMouseOver();
        this.watchOnMouseLeave();
        this.watchOnMouseMove();
        this.watchOnMouseDown();
        this.watchOnMouseUp();
        this.watchOnBodyClick();
    }

    public removeSubscribersByKey(key: string) {
        if (this.resizeWatchers.has(key)) {
            this.resizeWatchers.delete(key);
        }
        if (this.loadWatchers.has(key)) {
            this.loadWatchers.delete(key);
        }        
        if (this.documentClickWatchers.has(key)) {
            this.documentClickWatchers.delete(key);
        }
        if (this.escPressWatchers.has(key)) {
            this.escPressWatchers.delete(key);
        }
        if (this.deletePressWatchers.has(key)) {
            this.deletePressWatchers.delete(key);
        }   
        if (this.scrollWatchers.has(key)) {
            this.scrollWatchers.delete(key);
        }
        if (this.unloadWatchers.has(key)) {
            this.unloadWatchers.delete(key);
        }        
        if (this.messageWatchers.has(key)) {
            this.messageWatchers.delete(key);
        }
        if (this.popStateWatchers.has(key)) {
            this.popStateWatchers.delete(key);
        } 
         if (this.contextMenuWatchers.has(key)) {
            this.contextMenuWatchers.delete(key);
        }
        if (this.mouseOverWatchers.has(key)) {
            this.mouseOverWatchers.delete(key);
        } 
        if (this.mouseLeaveWatchers.has(key)) {
            this.mouseLeaveWatchers.delete(key);
        } 
        if (this.mouseMoveWatchers.has(key)) {
            this.mouseMoveWatchers.delete(key);
        }
        if (this.mouseDownWatchers.has(key)) {
            this.mouseDownWatchers.delete(key);
        }
        if (this.mouseUpWatchers.has(key)) {
            this.mouseUpWatchers.delete(key);
        } 
        if (this.bodyClickWatchers.has(key)) {
            this.bodyClickWatchers.delete(key);
        }
        
        if (this.customerEventWatchers.size) {
            for (const v of this.customerEventWatchers.values()) {
                if (v.has(key)) {
                    v.delete(key);
                }
            }
        }
    }

    public onResize(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.resizeWatchers.has(key)) {
                functions = this.resizeWatchers.get(key);
            }
    
            functions.push(callback);
            this.resizeWatchers.set(key, functions);
        }
    }

    public onLoad(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.loadWatchers.has(key)) {
                functions = this.loadWatchers.get(key);
            }
    
            functions.push(callback);
            this.loadWatchers.set(key, functions);
        }
    }

    public onEscPress(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.escPressWatchers.has(key)) {
                functions = this.escPressWatchers.get(key);
            }
    
            functions.push(callback);
            this.escPressWatchers.set(key, functions);
        }
    }

    public onDeletePress(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.deletePressWatchers.has(key)) {
                functions = this.deletePressWatchers.get(key);
            }
    
            functions.push(callback);
            this.deletePressWatchers.set(key, functions);
        }
    }

    public onScreenClick(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.documentClickWatchers.has(key)) {
                functions = this.documentClickWatchers.get(key);
            }
    
            functions.push(callback);
            this.documentClickWatchers.set(key, functions);
        }
    }

    public onScroll(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.scrollWatchers.has(key)) {
                functions = this.scrollWatchers.get(key);
            }
    
            functions.push(callback);
            this.scrollWatchers.set(key, functions);
        }
    }

    public onUnload(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.unloadWatchers.has(key)) {
                functions = this.unloadWatchers.get(key);
            }
    
            functions.push(callback);
            this.unloadWatchers.set(key, functions);
        }
    }

    public onMessage(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.messageWatchers.has(key)) {
                functions = this.messageWatchers.get(key);
            }
    
            functions.push(callback);
            this.messageWatchers.set(key, functions);
        }
    }

    public onContextMenu(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.contextMenuWatchers.has(key)) {
                functions = this.contextMenuWatchers.get(key);
            }
    
            functions.push(callback);
            this.contextMenuWatchers.set(key, functions);
        }
    }

    public onPopStateChange(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.popStateWatchers.has(key)) {
                functions = this.popStateWatchers.get(key);
            }
    
            functions.push(callback);
            this.popStateWatchers.set(key, functions);
        }
    }

    public onMouseOver(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.mouseOverWatchers.has(key)) {
                functions = this.mouseOverWatchers.get(key);
            }
    
            functions.push(callback);
            this.mouseOverWatchers.set(key, functions);
        }
    }

    public onMouseLeave(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.mouseLeaveWatchers.has(key)) {
                functions = this.mouseLeaveWatchers.get(key);
            }
    
            functions.push(callback);
            this.mouseLeaveWatchers.set(key, functions);
        }
    }

    public onMouseMove(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.mouseMoveWatchers.has(key)) {
                functions = this.mouseMoveWatchers.get(key);
            }
    
            functions.push(callback);
            this.mouseMoveWatchers.set(key, functions);
        }
    }

    public onMouseDown(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.mouseDownWatchers.has(key)) {
                functions = this.mouseDownWatchers.get(key);
            }
    
            functions.push(callback);
            this.mouseDownWatchers.set(key, functions);
        }
    }

    public onMouseUp(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.mouseUpWatchers.has(key)) {
                functions = this.mouseUpWatchers.get(key);
            }
    
            functions.push(callback);
            this.mouseUpWatchers.set(key, functions);
        }
    }

    public onBodyClick(key: string, callback: Function) {
        if (callback) {
            let functions: Array<Function> = [];
            if (this.bodyClickWatchers.has(key)) {
                functions = this.bodyClickWatchers.get(key);
            }
    
            functions.push(callback);
            this.bodyClickWatchers.set(key, functions);
        }
    }

    public onCustomEvent(key: string, ev: CustomEventTypes, callback: Function) {
        if (key && ev && callback) {
            const e = this.customerEventWatchers.has(ev) ? this.customerEventWatchers.get(ev) : new Map<string, Array<Function>>();
            
            let events = [callback];
            if (e.has(key)) {
                const existingEvents = e.get(key);
                if (existingEvents) {
                    existingEvents.push(callback);
                    events = existingEvents;
                }
            }

            e.set(key, events);
            
            this.customerEventWatchers.set(ev, e);
            this.subscribeCustomeEvent(ev);
        }
    }

    private registerEvents: Array<CustomEventTypes> = [];
    private subscribeCustomeEvent(ev: CustomEventTypes) {
        if (this.registerEvents.some((x: CustomEventTypes) => x == ev)) return;

        this.registerEvents.push(ev);
        document.addEventListener(ev, (e: any) => {
            const callbacks = this.customerEventWatchers.get(ev);
            if (callbacks) {
                for (const v of callbacks.values()) {
                    for (const cb of v) {
                        cb(e.detail);
                    }
                }
            }
        });
    }

    public triggerCustomEvent(eventName: string, params?: any) {
        let event: any = null;
        if (window.CustomEvent) {
            event = new CustomEvent(eventName, params);
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, params);
        }

        document.dispatchEvent(event);
    }

    private watchOnResize() {
        window.addEventListener('resize', (e: any) => {
            this.resizeWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

   
    private watchOnLoad() {
        window.addEventListener('load', (e: any) => {
            this.loadWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchEscPress() {
        document.addEventListener('keyup', (ev: any) => {
            if (ev.keyCode === 27) {
                this.escPressWatchers.forEach((functions: Array<Function>) => {
                    functions.forEach((call: any) => {
                        call(ev);
                    });
                });
            }
        });
    }

    private watchDeletePress() {
        document.addEventListener('keyup', (ev: any) => {
            if (ev.keyCode === 46) {
                this.deletePressWatchers.forEach((functions: Array<Function>) => {
                    functions.forEach((call: any) => {
                        call(ev);
                    });
                });
            }
        });
    }

    private watchDocumentClick() {
        document.addEventListener('click', (ev: any) => {
            this.documentClickWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(ev);
                });
            });
        });
    }

    private watchOnScroll() {
        document.addEventListener('scroll', (e: any) => {
            this.scrollWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        },
        {
            passive: true
        });
    }

    private watchOnWindowUnload() {
        window.addEventListener('beforeunload', (e: any) => {
            this.unloadWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnMessage() {
        window.addEventListener('message',(e: any) => {
            this.messageWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnPopStateChange() {
        window.addEventListener('popstate',(e: any) => {
            this.popStateWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }
    
    private watchOnContextMenu() {
        window.addEventListener('contextmenu',(e: any) => {
            this.contextMenuWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }
    
    private watchOnMouseOver() {
        document.body.addEventListener('mouseover', (e: any) => {
            this.mouseOverWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnMouseLeave() {
        document.body.addEventListener('mouseleave', (e: any) => {
            this.mouseLeaveWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnMouseMove() {
        document.body.addEventListener('mousemove', (e: any) => {
            this.mouseMoveWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnMouseDown() {
        document.body.addEventListener('mousedown', (e: any) => {
            this.mouseDownWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnMouseUp() {
        document.body.addEventListener('mouseup', (e: any) => {
            this.mouseUpWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }

    private watchOnBodyClick() {
        document.body.addEventListener('click', (e: any) => {
            this.bodyClickWatchers.forEach((functions: Array<Function>) => {
                functions.forEach((call: any) => {
                    call(e);
                });
            });
        });
    }
}